import { useTranslation } from "react-i18next";
import moment from "moment";
import { makeStyles } from "@material-ui/core";
import { format } from "date-fns";
import {
  formatTestsWithNote,
  getFormatedTestListWithNoteForPxComponent,
  getPatientExaminationFindingsProcedureText,
} from "./PxPDFModel";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: "#f78f2d",
  },
  emptyStateText: {
    textAlign: "center",
    color: "#f78f2d",
  },
  header: {
    fontSize: 16,
    fontWeight: 600,
    color: "#000000",
    fontFamily: `"Poppins"`,
    paddingBottom: 15,
  },
  content: {
    fontSize: 14,
    fontWeight: 400,
    color: "#000000",
    fontFamily: `"Poppins"`,
    lineHeight: 2,
    paddingBottom: 25,
    wordBreak: "break-word",
  },
  followUp: {
    fontSize: 14,
    fontWeight: 400,
    color: "#000000",
    fontFamily: `"Poppins"`,
  },
  followUpDate: {
    fontSize: 14,
    fontWeight: 600,
    color: "#000000",
    fontFamily: `"Poppins"`,
  },
}));

function PrescriptionView({ px }) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <span className="divider"></span>
      <div>
        <h3 className={classes.header}>{t("px.consultationTypeHeader")}</h3>
        <ul className="list-unstyled list_test">
          {px.consultationType ? px.consultationType : "NA"}
        </ul>
      </div>

      {(px?.procedureChips || px?.examinationChips) && (
        <span className="divider"></span>
      )}

      {px?.examinationChips && (
        <div>
          <h3 className={classes.header}>{t("px.examinationHeader")}</h3>
          <ul className="list-unstyled list_test">
            {getPatientExaminationFindingsProcedureText(
              px?.examinationChips?.examinations
            )}
          </ul>
        </div>
      )}

      {px?.procedureChips && (
        <div className="mt-2">
          <h3 className={classes.header}>{t("px.procedureHeader")}</h3>
          <ul className="list-unstyled list_test">
            {getPatientExaminationFindingsProcedureText(
              px?.procedureChips?.procedures
            )}
          </ul>
        </div>
      )}
      {(px?.pathologyChips || px?.radiologyChips) && (
        <span className="divider"></span>
      )}
      {px?.pathologyChips && (
        <div>
          <h3 className={classes.header}>{t("px.pathologyHeader")}</h3>
          <ul className="list-unstyled list_test">
            {getFormatedTestListWithNoteForPxComponent(
              px?.pathologyChips?.investigations,
              px?.pathologyChips?.note
            )?.map((test, index) => (
              <li key={index}>
                <span className={classes.content}>
                  {(index + 1).toString() + " . " + test}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
      <br />
      {px?.radiologyChips && (
        <div>
          <h3 className={classes.header}>{t("px.bodyScanHeader")}</h3>
          <ul className="list-unstyled list_test">
            {getFormatedTestListWithNoteForPxComponent(
              px?.radiologyChips?.investigations,
              px?.radiologyChips?.note
            )?.map((test, index) => (
              <li key={index}>
                <span className={classes.content}>
                  {(index + 1).toString() + " . " + test}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {px?.followUpDate && (
        <div>
          <span className="divider"></span>
          <div className="recommended_block">
            <p className={classes.followUp}>
              {t("px.followUpText")}
              <span className={classes.followUpDate}>
                {moment(new Date(px.followUpDate)).format("DD MMM'YY")}
              </span>
            </p>
          </div>
        </div>
      )}

      <span className="divider"></span>
      {px?.advices?.length > 0 && (
        <div>
          <h3 className={classes.header}>{t("px.spAdviceHeader")}</h3>
          <div style={{ whiteSpace: "pre-wrap" }} className={classes.content}>
            {px.advices}
          </div>
        </div>
      )}
      {px?.instructions?.length > 0 && (
        <div>
          <h3 className={classes.header}>{t("px.spInstructionsHeader")}</h3>
          <div style={{ whiteSpace: "pre-wrap" }} className={classes.content}>
            {px.instructions}
          </div>
        </div>
      )}
    </>
  );
}

export default PrescriptionView;
